import { Modifier, EditorState } from "draft-js";
import { filterEmptyBlocks } from "lib/helpers";
import { convertHtmlToDraftContent } from "lib/convert/html";

/**
 *
 * @param {DraftEditorStore} store
 * @param {Draft.SelectionState} selection
 * @param {string} html
 */
export function insertHtml(store, selection, html) {
	const editorState = store.getEditorState();
	const currentContent = editorState.getCurrentContent();
	const pastedContent = filterEmptyBlocks(convertHtmlToDraftContent(html));

	let fragment = pastedContent.getBlockMap();
	if (fragment.size === 1) {
		fragment = fragment.merge({
			[genKey()]: convertFromRaw({
				blocks: [{ type: 'unstyled', text: '' }],
				entityMap: {}
			}).getFirstBlock()
		});
	}

	const newContent = Modifier.replaceWithFragment(
		currentContent,
		selection,
		fragment,
	);
	store.setEditorState(
		EditorState.push(editorState, newContent, 'insert-fragment'),
	);
}



// WEBPACK FOOTER //
// ./lib/helpers/insertHtml.js